// src/config/customerLabels.js
// Per-client wording, picked with VUE_APP_CLIENT (see featureFlags.js)
import { CLIENT } from '@/config/featureFlags';

const LABELS = {
  default: {
    product: 'Product',
    project: 'Session',
    licenseNo: 'License No',
    appName: 'eLogbook',
    practicalManager: 'Product Manager',
    projectManager: 'Classroom Session Manager',
  },
  airfrance: {
    product: 'Practical Element',
    licenseNo: 'Pro ID',
    appName: 'eSyllabus',
    practicalManager: 'Practical Element Manager',
    projectManager: 'Session Manager',
  },
};

export default { ...LABELS.default, ...(LABELS[CLIENT] || {}) };
